import type { AxiosInstance, AxiosError } from 'axios';
import { getAuthSessionHandlers } from '@/shared/api/auth-session-handlers';
import type { ApiRequestConfig } from '@/shared/api/types';
import { tokenStore } from '@/shared/api/token-store';
import { isSessionInvalidatedError } from './session-invalidation.interceptor';

export function applyTokenRefreshInterceptor(client: AxiosInstance): void {
  client.interceptors.response.use(
    (response) => response,
    async (error: AxiosError<{ code?: string }>) => {
      const config = error.config as ApiRequestConfig | undefined;
      if (!config) return Promise.reject(error);

      if (
        error.response?.status !== 401 ||
        config.skipSessionInvalidation ||
        isSessionInvalidatedError(error) ||
        (config._retryCount ?? 0) >= 1
      ) {
        return Promise.reject(error);
      }

      try {
        // refreshAccessToken dedupes via refreshSessionOnce() in auth-store.
        await getAuthSessionHandlers().refreshAccessToken();
        config._retryCount = (config._retryCount ?? 0) + 1;
        const token = tokenStore.get();
        if (token && config.headers) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return client(config);
      } catch {
        return Promise.reject(error);
      }
    },
  );
}
